import { useTranslation } from "react-i18next";

import { Input } from "@/components/ui/input/Input";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { ChangeEventHandler } from "react";

interface SearchSurnamesProps {
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

export const SearchSurnames = ({ value, onChange }: SearchSurnamesProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center gap-2 min-w-sm">
      <Paragraph>{t("invites.search.title")}</Paragraph>
      <Input
        placeholder={t("invites.search.placeholder")}
        value={value}
        onChange={onChange}
        className="max-w-sm"
      />
    </div>
  );
};
